import React from 'react'
import { IProxyPackage } from '../../models/user'

export const residentialSessionTimeIntervals = [
  {
    label: '1 min',
    value: '60',
  },
  {
    label: '5 mins',
    value: '300',
  },
  {
    label: '10 mins',
    value: '600',
  },
  {
    label: '60 mins',
    value: '3600',
  },
  {
    label: 'Custom, secs',
    value: 'custom',
  },
]

export const mobileSessionTimeIntervals = [
  {
    label: '1 min',
    value: '60',
  },
  {
    label: '5 mins',
    value: '300',
  },
  {
    label: '10 mins',
    value: '600',
  },
  {
    label: '60 mins',
    value: '3600',
  },
  {
    label: 'Custom, secs',
    value: 'custom',
  },
]

export const dcSessionTimeIntervals = [
  {
    label: '10 mins',
    value: '600',
  },
  {
    label: '60 mins',
    value: '3600',
  },
  {
    label: '12 hours',
    value: '43200',
  },
  {
    label: '24 hours',
    value: '86400',
  },
  {
    label: 'Custom, secs',
    value: 'custom',
  },
]

export const ispSessionTimeIntervals = [
  {
    label: '10 mins',
    value: '600',
  },
  {
    label: '60 mins',
    value: '3600',
  },
  {
    label: '12 hours',
    value: '43200',
  },
  {
    label: '24 hours',
    value: '86400',
  },
  {
    label: 'Custom, secs',
    value: 'custom',
  },
]

export const bindTtlOptions = [
  { label: '5 sec', value: '5' },
  { label: '10 sec', value: '10' },
  { label: '15 sec', value: '15' },
  { label: '20 sec', value: '20' },
  { label: '30 sec', value: '30' },
  { label: '1 min', value: '60' },
  { label: '2 min', value: '120' },
  { label: '5 min', value: '300' },
  { label: '10 min', value: '600' },
  { label: '20 min', value: '1200' },
  { label: 'Custom, secs', value: 'custom' },
]

export const defaultBindTtlOption = { label: '5 sec', value: '5' }

export const bindTtlMinSeconds = 1

export const bindTtlMaxByProxyType: Record<string, number> = {
  wifi: 14400, // Residential: 4 hours
  mobile: 3600, // Mobile: 1 hour
  dc: 86400, // Datacenter: 24 hours
  isp: 86400, // ISP: 24 hours
}

export const residentialSessionDefaultInterval = {
  label: '5 mins',
  value: '300',
}

export const mobileSessionDefaultInterval = {
  label: '5 mins',
  value: '300',
}

export const dcSessionDefaultInterval = {
  label: '10 mins',
  value: '600',
}

export const ispSessionDefaultInterval = {
  label: '10 mins',
  value: '600',
}

export const dcAvailableCountries = {
  de: {
    name: 'Germany',
    id: 57,
    code: 'de',
  },
  es: {
    name: 'Spain',
    id: 68,
    code: 'es',
  },
  fr: {
    name: 'France',
    id: 75,
    code: 'fr',
  },
  pl: {
    name: 'Poland',
    id: 179,
    code: 'pl',
  },
  gb: {
    name: 'United Kingdom',
    id: 77,
    code: 'gb',
  },
  us: {
    name: 'United States',
    id: 234,
    code: 'us',
  },
}

export const ispAvailableCountries = {
  us: {
    name: 'United States',
    id: 234,
    code: 'us',
  },
}

/*
export const credResultSample1 =
  'package-246842-pool-{{proxy_type}}{{location}}-sessionid-{{session_prefix}}{{session_length}}'

export const urlResultSample1 =
  'package-246842-pool-{{proxy_type}}{{location}}-sessionid-{{session_prefix}}{{session_length}}:UJWOUJZBIPb0swh2@proxy.soax.com:5000'

export const urlResultSample =
  'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}:{{package_key}}@{{host}}:5000'

export const proxyListResultSample1 =
  'package-246842-pool-{{proxy_type}}{{location}}-sessionid-{{session_prefix}}{{session_length}}:UJWOUJZBIPb0swh2@proxy.soax.com:5000'

export const proxyListResultSample =
  'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}:{{package_key}}@{{host}}:5000'
*/

export const curlResultSample =
  'curl -k -x package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000 -L https://checker.soax.com/api/ipinfo'

export const credResultSample =
  'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}'

export const urlResults = {
  option1:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option2:
    '{{host}}:5000:package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}',
  option3:
    'http://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option4:
    'https://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option5:
    'socks5://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option6:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}:{{host}}:5000',
  option7:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}},{{package_key}},{{host}},5000',
}

export const proxyListResults = {
  option1:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option2:
    '{{host}}:5000:package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}',
  option3:
    'http://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option4:
    'https://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option5:
    'socks5://package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}@{{host}}:5000',
  option6:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}}:{{package_key}}:{{host}}:5000',
  option7:
    'package-{{package_id}}{{location}}{{session_prefix}}{{session_length}}{{proxy_modifier}},{{package_key}},{{host}},5000',
}

export const getProxyPoolDescription = () => (
  <div>
    <p>
      <b>Residential Proxies:</b> Uses IP addresses from real homes, making it
      appear as legitimate user traffic, ideal for web scraping and accessing
      geo-restricted content.
    </p>
    <p>
      <b>Mobile Proxies:</b> Uses IPs from mobile carriers, frequently rotating,
      providing high anonymity for mobile app testing and managing multiple
      accounts.
    </p>
    <p>
      <b>USA Datacenter Proxies:</b> Uses IPs from USA data centers, offering high speed
      and cost-effectiveness, but easier to detect and block.
    </p>
  </div>
)

export const ProxyPoolDescription = getProxyPoolDescription()

export const defaultHostValue = 'proxy.soax.com'
export const resellerHostValue = 'reseller.soax.com'

export const defaultSpaceSymbol = '+'
export const defaultAmpersandSymbol = '&'

export const defaultOutputMaskOptionIndex = 0

export const proxyCheckerAvailableMaskOptionsIndexes = [0, 1]

export const outputMaskOptions = [
  {
    label: '1. username : password @ host : port',
    value: 'option1',
    notice: 'Software ready',
  },
  {
    label: '2. host : port : username : password',
    value: 'option2',
    notice: 'Proxy checker ready',
  },
  {
    label: '3. http:// username : password @ host : port',
    value: 'option3',
  },
  {
    label: '4. https:// username : password @ host : port',
    value: 'option4',
  },
  {
    label: '5. socks5:// username : password @ host : port',
    value: 'option5',
  },
  {
    label: '6. username : password : host : port',
    value: 'option6',
  },
  {
    label: '7. username , password , host , port',
    value: 'option7',
  },
]

export const proxyModifiers = [
  {
    label: 'Disabled',
    value: '',
  },
  {
    label: 'Web browser mode',
    value: '-opt-wb',
    description:
      'Optimized for browser-based activity. Increases error tolerance and reduces session interruptions.',
  },
  {
    label: 'Look-a-like mode',
    value: '-opt-lookalike',
    description:
      'When a node rotation occurs, this mode selects a new IP that closely resembles the previous one — simulating natural behavior like switching from Wi-Fi to mobile or moving between cell towers.',
  },
]

export const defaultProxyModifier = ''

export const defaultProxyPackages: IProxyPackage[] = [
  {
    id: '000000',
    package_key: 'SUBSCRIBE_TO_USE',
    connection_type: 'mobile',
    session_length: 3600,
  },
  {
    id: '000000',
    package_key: 'SUBSCRIBE_TO_USE',
    connection_type: 'wifi',
    session_length: 3600,
  },
  {
    id: '000000',
    package_key: 'SUBSCRIBE_TO_USE',
    connection_type: 'isp',
    session_length: 3600,
  },
  {
    id: '000000',
    package_key: 'SUBSCRIBE_TO_USE',
    connection_type: 'dc',
    session_length: 3600,
  },
]

export const defaultProxyHosts = {
  domain: 'proxy.soax.com',
  server: '1.1.1.1',
}

export const MaximumProxyListConnections = 5000
